import { bindable } from 'aurelia-framework';

class App {
  @bindable showMenu = true;
}

export { App };
